module.exports = __webpack_public_path__ + "img/pmr-gala-concert.d07f4030.jpeg";